import API from "@/interceptors/Api";

export interface TransferAccountDto {
  accountId: string;
  institutionName: string;
  branch: string;
  accountNumber: string;
  fiscalName: string;
  fiscalNumber: string;
}

export interface CreateDirectTransferRequest {
  originAccount: TransferAccountDto;
  destinationAccount: TransferAccountDto;
  amount: number;
  description?: string;
  transferMode: string;
}

export interface CreateDirectTransferResponse {
  id: number;
  message: string;
  status: "CONFIRMED" | "PENDING" | "FAILED";
  executedAt: string;
}

/**
 * GET /api/v1/bank-transfers/{institution}/modes
 * Returns the transfer modes supported by the origin institution
 */
export const getSupportedTransferModes = async (
  institution: string,
): Promise<string[]> => {
  const response = await API.get<string[]>(
    `/bank-transfers/${encodeURIComponent(institution)}/modes`,
  );
  return response as unknown as string[];
};

/**
 * POST /api/v1/bank-transfers
 * Creates and executes a direct (one-off) transfer between accounts
 */
export const createDirectTransfer = async (
  payload: CreateDirectTransferRequest,
): Promise<CreateDirectTransferResponse> => {
  const response = await API.post<CreateDirectTransferResponse>(
    "/bank-transfers",
    payload,
  );
  return response as unknown as CreateDirectTransferResponse;
};
